import { render, staticRenderFns } from "./FormBuilderElementSettings.vue?vue&type=template&id=39418b7d&scoped=true&lang=pug&"
import script from "./FormBuilderElementSettings.vue?vue&type=script&lang=js&"
export * from "./FormBuilderElementSettings.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderElementSettings.vue?vue&type=style&index=0&id=39418b7d&prod&lang=sass&scoped=true&"
import style1 from "./FormBuilderElementSettings.vue?vue&type=style&index=1&id=39418b7d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39418b7d",
  null
  
)

/* custom blocks */
import block0 from "./FormBuilderElementSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports